import { CrossClientQueryAtomicClause } from '../../../models/CrossClient'
import React from 'react'

export interface CrossClientClausesProps {
  atomicClauses: CrossClientQueryAtomicClause[]
}
export const CrossClientClauses: React.FC<CrossClientClausesProps> = ({ atomicClauses }) => {
  return (
    <div className='d-flex flex-column gap-3'>
      {atomicClauses.map((clause, index) => (
        <div key={index} className='d-flex gap-2 align-items-center'>
          <i className='bi bi-x-diamond-fill zocks-text-info fs-6' />
          <div className='paragraph-small medium'>{clause.description}</div>
        </div>
      ))}
    </div>
  )
}
